export const ATTENDANTLEAVELIST_SEARCH = 'ATTENDANTLEAVELIST_SEARCH';
export const ATTENDANTLEAVELIST_PAGE = 'ATTENDANTLEAVELIST_PAGE';
export const ATTENDANTLEAVELIST_YEAR = 'ATTENDANTLEAVELIST_YEAR';
